import checkout from "./form";

const {
  formField: {
    type,
    description,
  emailBody,
  emailTitle,
  attachment,
  },
} = checkout;

const initialValues = {
  [type.name]:null,
  [description.name]:"",
  [emailBody.name]:"",
  [emailTitle.name]:"",
  [attachment.name]: "",


};

export default initialValues;